<template>
    <div class="pdv-main-container" :bg-color-purple="bgColorPurple" :bg-color-red="bgColorRed">
        <!--main-header :show-backpack="showBackpack" :show-promo-message="showPromoMessage" :hide-header="showAlternativeHeader"></main-header-->
        <NewHeader :show-backpack="showBackpack" :show-promo-message="showPromoMessage" :hide-header="showAlternativeHeader"></NewHeader>
        <slot></slot>
        <!--footer-pdv :hide-footer-mobile="hideFooterMobile" :hide-footer="showAlternativeHeader"></footer-pdv-->

        <NewFooter :hide-footer-mobile="hideFooterMobile" :hide-footer="showAlternativeHeader"></NewFooter>

<!--        <chat-fixed-button :show-button-chat="showButtonChat"></chat-fixed-button>-->
        <backpack></backpack>
        <session-closed-alert-modal></session-closed-alert-modal>
        <session-expired-alert-modal></session-expired-alert-modal>
        <unknow-error-modal></unknow-error-modal>
        <courses-not-available />
        <close-session-alert-modal />
        <backpack-empty></backpack-empty>
        <!--site-not-available></site-not-available-->
        <a id="helperSessionModal" style="visibility:hidden;" href=".close-session-alert-modal" data-keyboard="false" data-toggle="modal"></a>
        <a id="helperSessionClosedModal" style="visibility:hidden;" href=".session-closed-alert-modal" data-keyboard="false" data-toggle="modal"></a>
        <a id="helperSessionExpiredModal" style="visibility:hidden;" href=".session-expired-alert-modal" data-keyboard="false" data-toggle="modal"></a>
        <a id="helperCoursesNotAvailable" style="visibility:hidden;" href=".courses-not-available-modal" data-keyboard="false" data-toggle="modal"></a>
        <a id="helperUnknowErrorModal" style="visibility:hidden;" href=".unknow-error-modal" data-keyboard="false" data-toggle="modal"></a>
        <a id="helperSiteNotAvailable" style="visibility:hidden;" href=".modal-no-disponible" data-keyboard="false" data-toggle="modal"></a>       
    </div>
</template>

<script>
    import MainHeader from "@/components/Header";
    import FooterPdv from "@/components/Footer";
    import NewFooter from "@/components/NewFooter";
    import NewHeader from "@/components/NewHeader";
    // import ChatFixedButton from "@/components/ChatFixedButton";
    import Backpack from "@/components/modals/Backpack";
    import CloseSessionAlertModal from "@/components/modals/CloseSessionAlertModal";
    import SessionClosedAlertModal from "@/components/modals/SessionClosedAlertModal";
    import SessionExpiredAlertModal from "@/components/modals/SessionExpiredAlertModal";
    import UnknowErrorModal from "@/components/modals/UnknowErrorModal";
    import CoursesNotAvailable from "@/components/modals/CoursesNotAvailable";
    import BackpackEmpty from "@/components/modals/BackpackEmpty"
   
    export default {
        components:{
            MainHeader,
            FooterPdv,
            // ChatFixedButton,
            Backpack,
            CloseSessionAlertModal,
            SessionClosedAlertModal,
            SessionExpiredAlertModal,
            UnknowErrorModal,
            BackpackEmpty,
            CoursesNotAvailable,
            NewFooter,
            NewHeader
        },
        props:{
            hideFooterMobile: {
                default: false
            },

            bgColorRed:{
              default: false
            },
            showAlternativeHeader: {
                default: false
            },
            bgColorPurple:{
              default: false
            },

            showButtonChat:{
                default: true
            },

            showBackpack:{
                default: true
            },

            showPromoMessage:{
                default: true
            }
        },
        created() {
            this.$store.dispatch('setInitialStudentInfo');
            this.$store.dispatch('setInitialStudents');

            this.$store.dispatch('setInitialCaretakerInfo');

            this.$store.dispatch('setInitialFinancingPartyInfo');

            this.$store.dispatch('setInitialSelectedProgramInfo');

            this.$store.dispatch('setInitialSubject');

            this.$store.dispatch('setInitialSubjectWithCourses');

            this.$store.dispatch('setInitialSelectedCourses');

            this.$store.dispatch('setInitialSelectedLocation');

            this.$store.dispatch('setInitialFullOrderData');

            this.$store.dispatch('setInitialBackpackVisible');

            this.$store.dispatch('setInitialStudentsWithPrices');

            this.$store.dispatch('setInitialCoursesNotAvailables');
            
            this.$store.dispatch('setInitialProgramDataForRecommend');

            this.$store.dispatch('setInitialFormatProgramName');
        }
    }
</script>

<style lang="scss">
    .pdv-main-container{
        position: relative;
        min-height: 100vh;
        padding-bottom: 0;
        @media (min-width: 450px) {
            padding-bottom: 0;
        }
    }
    .form-group.error > :last-child {
        color : orange;
        font-style: italic;
        font-size: 13px;
        font-weight: 500;
    }
    input:-webkit-autofill,
    input:-webkit-autofill:hover, 
    input:-webkit-autofill:focus, 
    input:-webkit-autofill:active  {
        -webkit-transition: "color 9999s ease-out, background-color 9999s ease-out";
        -webkit-transition-delay: 9999s;
    }
</style>